import * as Sentry from '@sentry/browser';
import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {environment} from '../../environments/environment';
import { Router } from '@angular/router';

Sentry.init({
  dsn: environment.sentryDSN
});

@Injectable({
  providedIn: 'root'
})
export class SentryErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) { }
  handleError(error: any) {
    const router = this.injector.get(Router);
    const eventId = Sentry.captureException(error.originalError || error);
  }
}
